import React, { FC } from "react";

interface FlightIconProps {
  className: string;
}

const FlightIcon: FC<FlightIconProps> = ({ className }) => {
  return (
   <svg   xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" width="24" height="24" className={`MuiTab-iconWrapper alm-desktop-118h5qt -rotate-45 ${className}`}><path d="M3.76056 11.9894L2.26056 8.23944L5.26056 8.23944L6.76056 9.73944L9.76056 9.73944L8.26056 2.23944L11.2606 2.23944L15.0106 9.73944L19.5106 9.74999C20.1073 9.74999 20.6796 9.98705 21.1015 10.409C21.5235 10.831 21.7606 11.4033 21.7606 12C21.7606 12.5967 21.5235 13.169 21.1015 13.591C20.6796 14.0129 20.1073 14.25 19.5106 14.25L15.0106 14.2605L11.2606 21.7605L8.26056 21.7605L9.76056 14.2605L6.76056 14.2605L5.26056 15.7394L2.26056 15.7394L3.76056 11.9894Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>

  );
};

export default FlightIcon;
